import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/FaviconImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/FooterLanguageLinks.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/Header.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/product-editorial/editorial-product.module.css");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/featured-tools-list.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/ProductHeader.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/video/VideoPlayer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/VisitWebsiteButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/opt/buildhome/repo/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/public/icon.png");
